import operationalReportsImg from 'assets/images/operational_reports.png';
import activityReportsImg from 'assets/images/activity_reports.png';
import energyReportsImg from 'assets/images/energy_reports.png';

const reports = {
    id: 'reports',
    title: 'Reports',
    type: 'group',
    children: [
        {
            id: 'operational-reports',
            title: 'Operational Reports',
            type: 'collapse',
            icon: operationalReportsImg,

            children: [
                {
                    id: 'reports-battery-health',
                    title: 'Battery Health',
                    type: 'item',
                    url: '/operational-reports/battery-health',
                    breadcrumbs: false
                },
                {
                    id: 'reports-asset-inventory',
                    title: 'Asset Inventory',
                    type: 'item',
                    url: '/operational-reports/asset-inventory',
                    breadcrumbs: false
                },
                {
                    id: 'reports-device-type',
                    title: 'Device Type (%)',
                    type: 'item',
                    url: '/operational-reports/device-type',
                    breadcrumbs: false
                },
                {
                    id: 'reports-license-summary',
                    title: 'License Summary',
                    type: 'item',
                    url: '/operational-reports/license-summary',
                    breadcrumbs: false
                },
                {
                    id: 'reports-policy-summary',
                    title: 'Policy Summary',
                    type: 'item',
                    url: '/operational-reports/policy-summary',
                    breadcrumbs: false
                },
                {
                    id: 'reports-group-summary',
                    title: 'Group Summary',
                    type: 'item',
                    url: '/operational-reports/group-summary',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'activity-reports',
            title: 'Activity Reports',
            type: 'collapse',
            icon: activityReportsImg,

            children: [
                {
                    id: 'reports-device-usage',
                    title: 'Device Usage',
                    type: 'item',
                    url: '/activity-reports/device-usage',
                    breadcrumbs: false
                },
                {
                    id: 'reports-device-time',
                    title: 'Device vs Time',
                    type: 'item',
                    url: '/activity-reports/device-time',
                    breadcrumbs: false
                },
                {
                    id: 'reports-powerstate',
                    title: 'Power states vs Time',
                    type: 'item',
                    url: '/activity-reports/powerstate',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'reports-energy',
            title: 'Energy Reports',
            type: 'collapse',
            icon: energyReportsImg,

            children: [
                {
                    id: 'reports-savings-summary',
                    title: 'Savings Summary',
                    type: 'item',
                    url: '/energy-reports/savings-summary',
                    breadcrumbs: false
                },
                {
                    id: 'reports-baseline',
                    title: 'Baseline Audit',
                    type: 'item',
                    url: '/energy-reports/baseline-audit',
                    breadcrumbs: false
                }
                /* {
                     id: 'reports-savings',
                     title: 'Savings Report',
                     type: 'item',
                     url: '/energy-reports/savings',
                     breadcrumbs: false
                 },
                 {
                     id: 'reports-annual',
                     title: 'Annual Report',
                     type: 'item',
                     url: '/energy-reports/annual',
                     breadcrumbs: false
                 }
*/
            ]
        } /*,
         {
              id: 'custom-reports',
              title: 'Custom Reports',
              type: 'collapse',
              icon: energyReportsImg,
        
              children: [
                  {
                  id: 'reports-custom',
                  title: 'Custom Report',
                  type: 'item',
                  url: '/custom-reports/custom',
                  breadcrumbs: false
                  }
              ]
         }*/
    ]
};

export default reports;
